module.exports = __webpack_public_path__ + "img/p-5-4.853cb728.png";